var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14h-1v-.8c0-2.12-.99-3.85-2.58-4.52a.73.73 0 0 1 0-1.36c1.6-.67 2.58-2.4 2.58-4.52V2h1a.5.5 0 0 0 0-1h-11a.5.5 0 1 0 0 1h1v.8c0 2.12.99 3.85 2.58 4.52a.73.73 0 0 1 0 1.36c-1.6.67-2.58 2.4-2.58 4.52v.8h-1a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1Zm-9 0v-.8c0-1.71.75-3.1 1.97-3.6a1.73 1.73 0 0 0 0-3.2C5.25 5.9 4.5 4.51 4.5 2.8V2h7v.8c0 1.71-.75 3.1-1.97 3.6a1.73 1.73 0 0 0 0 3.2c1.22.5 1.97 1.89 1.97 3.6v.8h-7Zm6.5-1a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 13a3 3 0 0 1 6 0Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.2a683f5fb9599d7ae1535a7c30f3475b.svg";
export { ForwardRef as ReactComponent };